var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthnic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504 504",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2,140h23.5c-0.6,3.4-1.1,7.3-1.1,11.2v11.2H11.2c-6.2,0-11.2-5-11.2-11.2C0,145,5,140,11.2,140L11.2,140z M492.8,140 h-23.5c0.6,3.4,1.1,7.3,1.1,11.2v11.2h22.4c6.2,0,11.2-5,11.2-11.2C504,145,499,140,492.8,140L492.8,140z M403.2,106.4H100.8 c-20.7,0-38.6,14-43.7,33.6h389.2C441.8,120.4,423.9,106.4,403.2,106.4L403.2,106.4z M438.5,262.6c4.5-14,7.8-29.1,9-44.2h-44.8 L438.5,262.6z M212.2,274.4h80.1L252,225.1L212.2,274.4z M379.1,225.1l-40.3,49.3h80.1L379.1,225.1z M57.1,218.4 c1.1,15.1,4.5,29.7,9,44.2l35.8-44.2L57.1,218.4z M315.3,267.7l39.8-49.3h-79.5L315.3,267.7z M56,196h392v-33.6H56V196z M85.1,274.4 h80.1l-39.8-49.3L85.1,274.4z M188.7,267.7l39.8-49.3h-80.1L188.7,267.7z M252,397.6c71.7,0,136.6-39.2,171.4-100.8H80.6 C115.4,358.4,180.3,397.6,252,397.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthnic);
export default __webpack_public_path__ + "static/media/ethnic.985bba9d672a2c400536109c3d543a40.svg";
export { ForwardRef as ReactComponent };